module.exports = __webpack_public_path__ + "static/media/tipo_gasto.bcd0db85.svg";